import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link as RouterLink } from 'react-router-dom';
import * as Icons from '@mui/icons-material';
import {
    Box,
    Typography,
    Paper,
    Button,
    TextField,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions
} from '@mui/material';
import { Add, Search, Preview, Vaccines, MedicalServices } from '@mui/icons-material';
import axios from 'axios';
import { Edit, Delete } from '@mui/icons-material';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useTheme } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const PatientHistory = () => {
    const { idPac } = useParams();
    const navigate = useNavigate();
    const [patient, setPatient] = useState(null);
    const [historias, setHistorias] = useState([]);
    const [newHistory, setNewHistory] = useState({
        HistoriaT: '',
        Diagnostico: '',
        Tratamiento: '',
        Responsable: '',
        costo_consulta: 0
    });
    const [user, setUser] = useState(null);
    const [open, setOpen] = useState(false);
    const [openViewModal, setOpenViewModal] = useState(false);
    const [selectedHistory, setSelectedHistory] = useState(null);
    const [openPatientInfoModal, setOpenPatientInfoModal] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 5,
        page: 0,
    });
    const [hasNextPatient, setHasNextPatient] = useState(false);
    const [hasPreviousPatient, setHasPreviousPatient] = useState(false);
    const [tempTratamiento, setTempTratamiento] = useState("");
    const [navigationLoading, setNavigationLoading] = useState(false);

    // Snackbar/Alert state
    const [setAlert] = useState('');
    const [setSeverity] = useState('info');
    const [setSnackbar] = useState(false);
    
    const handleChangeTratamiento = (e) => {
        setTempTratamiento(e.target.value);
        setNewHistory({ ...newHistory, Tratamiento: e.target.value });
    };

   /* const handleOpenRecipe = () => {
        if (selectedHistory || tempTratamiento) {
          const tratamientoToSend = selectedHistory?.Tratamiento || tempTratamiento;
          navigate(`/recipe/${selectedHistory?.IDHistoria || 'new'}`, { 
            state: { 
              tratamiento: tratamientoToSend,
              historia: newHistory.HistoriaT,
              diagnostico: newHistory.Diagnostico,
              responsable: newHistory.Responsable,
              patient: patient,
              costo_consulta: selectedHistory ? selectedHistory.costo_consulta : newHistory.costo_consulta
            } 
          });
        }
      };*/

    const handleOpenRecipe = () => {
    // Verificar si estamos en modo creación (open=true) o edición
    const isCreatingNew = open && !selectedHistory?.IDHistoria;
    
    // Determinar los datos a enviar
    const recipeData = {
        tratamiento: isCreatingNew ? tempTratamiento : selectedHistory?.Tratamiento,
        historia: isCreatingNew ? newHistory.HistoriaT : selectedHistory?.HistoriaT,
        diagnostico: isCreatingNew ? newHistory.Diagnostico : selectedHistory?.Diagnostico,
        responsable: isCreatingNew ? newHistory.Responsable : selectedHistory?.Responsable,
        patient: patient,
        costo_consulta: isCreatingNew ? newHistory.costo_consulta : selectedHistory?.costo_consulta,
        IDPac: patient.idpac,
        isNew: isCreatingNew
    };

    // Navegar a la página de receta
    navigate(`/recipe/${isCreatingNew ? 'new' : selectedHistory?.IDHistoria}`, {
        state: recipeData
    });
    };
    
    const recipeRef = useRef(null);
    //test carlos 1
    const columns = [
        { field: 'IDHistoria', headerName: 'ID Historia', width: 100 },
        { field: 'FechaDeLaHistoria', headerName: 'Fecha', width: 110 },
        { field: 'HistoriaT', headerName: 'Historia', width: 200 },
        { field: 'Diagnostico', headerName: 'Diagnóstico', width: 200 },
        { field: 'Tratamiento', headerName: 'Tratamiento', width: 200 },
        { field: 'Responsable', headerName: 'Responsable', width: 150 },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            width: 100,
            getActions: (params) => [
            <Box sx={{ display: 'flex', gap: '8px' }}>
                <GridActionsCellItem
                    variant="contained" 
                    color="primary" 
                    icon={<Edit />}
                    label="Editar"
                    onClick={() => handleOpenEditModal(params.row)}
                />,
                <GridActionsCellItem
                    variant="contained" 
                    color="secondary" 
                    icon={<Delete />}
                    label="Eliminar"
                    onClick={() => handleDeleteHistory(params.row.IDHistoria)}
                />,
            </Box>
            ],
        },
    ];

    const [openEditModal, setOpenEditModal] = useState(false);
    const [editingHistory, setEditingHistory] = useState(null);
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [historyToDelete, setHistoryToDelete] = useState(null);
    //const [allPatientIds, setAllPatientIds] = useState([]);

    const handleOpenEditModal = (history) => {
        setEditingHistory(history);
        setOpenEditModal(true);
    };
    const API_URL = process.env.REACT_APP_API_URL;
    const handleUpdateHistory = async () => {
        try {
            await axios.put(`${API_URL}/api/historias/${editingHistory.IDHistoria}`, {
                HistoriaT: editingHistory.HistoriaT,
                Diagnostico: editingHistory.Diagnostico,
                Tratamiento: editingHistory.Tratamiento,
                Responsable: editingHistory.Responsable,
                costo_consulta: editingHistory.costo_consulta
            });
    
            const updatedHistorias = historias.map(historia => 
                historia.IDHistoria === editingHistory.IDHistoria ? editingHistory : historia
            );
            
            setHistorias(updatedHistorias);
            setOpenEditModal(false);
        } catch (error) {
            console.error('Error al actualizar la historia:', error);
        }
    };
    
    const handleDeleteHistory = (id) => {
        setHistoryToDelete(id);
        setDeleteConfirmOpen(true);
    };
    
    const confirmDelete = async () => {
        try {
            await axios.delete(`${API_URL}/api/historias/${historyToDelete}`);
            const updatedHistorias = historias.filter(historia => historia.IDHistoria !== historyToDelete);
            setHistorias(updatedHistorias);
            setDeleteConfirmOpen(false);
        } catch (error) {
            console.error('Error al eliminar la historia:', error);
        }
    };

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user`, { withCredentials: true });
                setUser(response.data);
            } catch (error) {
                console.error('Error al obtener el usuario:', error);
            }
        };

        fetchUser();
    }, [API_URL]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setNavigationLoading(true);
                
                // Obtener datos en paralelo
                const [patientRes, adjacentsRes, historyRes] = await Promise.all([
                    axios.get(`${API_URL}/api/identificacion/${idPac}`),
                    axios.get(`${API_URL}/api/pacientes/adyacentes/${idPac}`),
                    axios.get(`${API_URL}/api/historias/${idPac}`)
                ]);
    
                setPatient(patientRes.data);
                setHasPreviousPatient(adjacentsRes.data.hasPrevious);
                setHasNextPatient(adjacentsRes.data.hasNext);
    
                // Formatear la fecha de las historias
                const historiasConId = historyRes.data.map((historia) => ({
                    ...historia,
                    id: historia.IDHistoria,
                    FechaDeLaHistoria: dayjs(historia.FechaDeLaHistoria)
                        .tz('America/Costa_Rica')
                        .format('YYYY-MM-DD HH:mm:ss')
                }));
                
                setHistorias(historiasConId);
            } catch (error) {
                console.error('Error al obtener datos:', error);
            } finally {
                setNavigationLoading(false);
            }
        };
    
        fetchData();
    }, [idPac, API_URL]);

     // Función optimizada para navegación
     const navigateToPatient = (direction) => async () => {
        try {
            setNavigationLoading(true);
            const { data } = await axios.get(
                `${API_URL}/api/pacientes/${direction}-paciente/${idPac}`
            );
            
            if (data.newId) {
                navigate(`/historias/${data.newId}`);
            }
        } catch (error) {
            console.error(`Error navegando a paciente ${direction}:`, error);
        } finally {
            setNavigationLoading(false);
        }
    };

    // In PatientHistory.js, modify the handleCreateHistory function:

    const handleCreateHistory = async () => {
        try {
            // Convertir a número y validar
            const costoConsulta = typeof newHistory.costo_consulta === 'number' 
                ? newHistory.costo_consulta 
                : Number(newHistory.costo_consulta) || 0;

            // Validar si el costo es negativo
            if (costoConsulta < 0) {
                setAlert("El costo de consulta no puede ser negativo");
                setSeverity("error");
                setSnackbar(true);
                return;
            }

            // Crear historia con costo validado
            await axios.post(`${API_URL}/api/historias`, {
                IDPac: idPac,
                HistoriaT: newHistory.HistoriaT,
                Diagnostico: newHistory.Diagnostico,
                Tratamiento: newHistory.Tratamiento,
                Responsable: user.username || '',
                costo_consulta: costoConsulta
            });

            // Fetch updated data
            const [patientRes, historyRes] = await Promise.all([
            axios.get(`${API_URL}/api/identificacion/${idPac}`),
            axios.get(`${API_URL}/api/historias/${idPac}`)
        ]);

        setPatient(patientRes.data);
        
        const historiasConId = historyRes.data.map(historia => ({
            ...historia,
            id: historia.IDHistoria,
            FechaDeLaHistoria: dayjs(historia.FechaDeLaHistoria)
                .tz('America/Costa_Rica')
                .format('YYYY-MM-DD HH:mm:ss')
        }));

        setHistorias(historiasConId);
        setOpen(false);
        setNewHistory({
            HistoriaT: '',
            Diagnostico: '',
            Tratamiento: '',
            Responsable: '',
            costo_consulta: ''
        });
        setTempTratamiento('');

    } catch (error) {
        console.error('Error al crear la historia:', error);
        setAlert("Error al crear la historia. Verifique los datos e intente nuevamente.");
        setSeverity("error");
        setSnackbar(true);
    }
};

    const handleClose = () => {
        setOpen(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewHistory(prev => ({
            ...prev,
            [name]: name === 'costo_consulta' ? (value === '' ? 0 : Number(value)) : value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        handleCreateHistory();
    };

    const calcularEdad = (birthdate) => {
        if (!birthdate) return 'N/A';
        const birthDate = new Date(birthdate);
        const today = new Date();

        let years = today.getFullYear() - birthDate.getFullYear();
        let months = today.getMonth() - birthDate.getMonth();
        let days = today.getDate() - birthDate.getDate();

        if (days < 0) {
            months--;
            const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            days += prevMonth.getDate();
        }
        if (months < 0) {
            years--;
            months += 12;
        }

        const pluralize = (value, singular, plural) => value === 1 ? singular : plural;

        if (years > 0) {
            return `${years} ${pluralize(years, 'año', 'años')}${months > 0 ? `, ${months} ${pluralize(months, 'mes', 'meses')}` : ''}`;
        } else if (months > 0) {
            return `${months} ${pluralize(months, 'mes', 'meses')}${days > 0 ? ` y ${days} ${pluralize(days, 'día', 'días')}` : ''}`;
        } else {
            return `${days} ${pluralize(days, 'día', 'días')}`;
        }
    };

    /*const handlePreviousPatient = () => {
        const currentId = parseInt(idPac);
        const prevPatient = allPatientIds[allPatientIds.indexOf(currentId) - 1];
        if (prevPatient) {
            navigate(`/historias/${prevPatient}`);
        }
    };

    const handleNextPatient = () => {
        const currentId = parseInt(idPac);
        const nextPatient = allPatientIds[allPatientIds.indexOf(currentId) + 1];
        if (nextPatient) {
            navigate(`/historias/${nextPatient}`);
        }
    };*/

    const handleShowPatientInfo = () => {
        setOpenPatientInfoModal(true);
    };

    const handleRowClick = (params) => {
        setSelectedHistory(params.row);
        setOpenViewModal(true);
    };

    const handleOpenCIE11 = () => {
        window.open('https://icd.who.int/browse/2024-01/mms/es', '_blank');
    };

    const theme = useTheme();

    const handleCopyLastTreatment = () => {
        if (historias.length > 0) {
            const lastTreatment = historias[0].Tratamiento;
            setTempTratamiento(lastTreatment);
            setNewHistory({ ...newHistory, Tratamiento: lastTreatment });
        }
    };
    
    const handleCopyLastDiagnosis = () => {
        if (historias.length > 0) {
            const lastDiagnosis = historias[0].Diagnostico;
            setNewHistory({ ...newHistory, Diagnostico: lastDiagnosis });
        }
    };
    
    return (
        <Box sx={{ 
            display: 'flex',
            padding: 2,
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            flexDirection: 'column' }}>
            <Paper
                elevation={3}
                sx={{
                    padding: { xs: 2, sm: 4 },
                    width: '100%',
                    maxWidth: '98vw',
                    overflowX: 'auto',
                    borderRadius: 2,
                    margin: 'auto',
                    boxSizing: 'border-box',
                    background: `linear-gradient(135deg, ${theme.palette.background.default} 0%,rgb(238, 245, 178) 100%)`,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                }}
            >
                <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                    Historias clínicas
                </Typography>
                <Typography variant="h6" gutterBottom>
                    {patient ? (
                        <>
                            <strong>Nombre:</strong> {patient.nombre} <strong>sexo:</strong> {patient.sexo} <strong>edad:</strong> {calcularEdad(patient.birthdate)}
                        </>
                    ) : (
                        'Cargando...'
                    )}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2, gap:2 }}>
                <Button
                    onClick={() => window.open('/diagnosticos-tratamientos', '_blank')}
                    variant="contained"
                    color="primary"
                    startIcon={<Vaccines />}
                >
                    Bioestadística
                </Button>
                <Button
                      onClick={() => window.open('/historias-hoy', '_blank')}
                      variant="contained"
                      color="primary"
                      startIcon={<Search />}
                  >
                      Historias de Hoy
                  </Button>
                </Box>
                </Typography>
                <div style={{ height: '50vh', width: '100%', minHeight: '300px'}}>
                <DataGrid
                    rows={historias}
                    columns={columns}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    pageSizeOptions={[5]}
                    onRowClick={handleRowClick}
                    disableRowSelectionOnClick
                    components={{
                        Toolbar: GridToolbar
                    }}
                    getRowId={(row) => row.id}
                />
                </div>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 1,
                        alignItems: 'center',
                        marginTop: 2,
                        width: '100%'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            width: '100%',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Icons.NavigateBefore />}
                            onClick={navigateToPatient('previous')}
                            disabled={!hasPreviousPatient || navigationLoading}
                            sx={{
                                width: { xs: '48%', sm: 'auto' },
                                order: { xs: 0, sm: 0 }
                            }}
                        >
                            {navigationLoading ? 'Cargando...' : 'Anterior'}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Preview />}
                            onClick={handleShowPatientInfo}
                            disabled={!patient}
                            sx={{
                                width: { xs: '48%', sm: 'auto' },
                                order: { xs: 1, sm: 0 }
                            }}
                        >
                            Ver paciente
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Icons.NavigateNext />}
                            onClick={navigateToPatient('next')}
                            disabled={!hasNextPatient || navigationLoading}
                            sx={{
                                width: { xs: '48%', sm: 'auto' },
                                order: { xs: 1, sm: 0 }
                            }}
                        >
                            {navigationLoading ? 'Cargando...' : 'Siguiente'}
                        </Button>
                    </Box>
    
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            width: '100%',
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}
                    >
                        <Button
                            variant="contained"
                            startIcon={<Add />}
                            onClick={() => setOpen(true)}
                            sx={{
                                width: { xs: '100%', sm: 'auto' },
                                order: { xs: 2, sm: 0 }
                            }}
                        >
                            Crear nueva historia
                        </Button>
    
                        <Button
                            startIcon={<Search />}
                            component={RouterLink}
                            to="/view-patients"
                            variant="contained"
                            color="primary"
                            sx={{
                                width: { xs: '100%', sm: 'auto' },
                                order: { xs: 3, sm: 0 }
                            }}
                        >
                            Buscar Pacientes
                        </Button>
                    </Box>
                </Box>
                <Dialog 
                    open={open} 
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                        handleClose();
                        }
                    }}
                    maxWidth="lg" 
                    fullWidth
                    disableEscapeKeyDown
                >
                <DialogTitle 
                            sx={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                fontWeight: 'bold', 
                                color: theme.palette.primary.main 
                            }}
                        >
                            <Typography variant="h6" component="div">
                                Crear Nueva Historia Clínica
                            </Typography>
                            {patient && (
                                <Typography variant="subtitle1" component="div">
                                    <strong>Nombre: </strong> {patient.nombre} <br></br> <strong>Edad: </strong> {calcularEdad(patient.birthdate)}
                                </Typography>
                            )}
                        </DialogTitle>
                    <DialogContent>
                        <form onSubmit={handleSubmit}>
                            <TextField
                                id="HistoriaT"
                                name="HistoriaT"
                                label="Historia"
                                value={newHistory.HistoriaT}
                                onChange={handleChange}
                                sx={{ width: '100%', marginBottom: '20px' }}
                                multiline
                                rows={12}
                            />
                            <TextField
                                id="Diagnostico"
                                name="Diagnostico"
                                label="Diagnóstico"
                                value={newHistory.Diagnostico}
                                onChange={handleChange}
                                sx={{ width: '100%', marginBottom: '20px' }}
                                multiline
                                rows={4}
                            />
                                                        <Button 
                            onClick={handleCopyLastDiagnosis} 
                            sx={{ width: '25%', marginBottom: '20px' }} 
                            variant="contained"
                            startIcon={<Icons.ContentCopy />} 
                            color="primary">
                                Copiar Último Diagnóstico
                            </Button>
                            <TextField
                                id="Tratamiento"
                                name="Tratamiento"
                                label="Tratamiento"
                                value={tempTratamiento}
                                onChange={handleChangeTratamiento}
                                sx={{ width: '100%', marginBottom: '20px' }}
                                multiline
                                rows={12}
                            />
                                                        <Button 
                            onClick={handleCopyLastTreatment}
                            sx={{ width: '25%', marginBottom: '20px' }} 
                            variant="contained"
                            startIcon={<Icons.ContentCopy />} 
                            color="primary">
                                Copiar Último Tratamiento
                            </Button>
                            <TextField
                                label="Costo Consulta"
                                name="costo_consulta"
                                value={newHistory.costo_consulta}
                                onChange={handleChange}
                                type="text"
                                inputProps={{ 
                                    inputMode: 'numeric',
                                    pattern: '[0-9]*.?[0-9]*'
                                }}
                                sx={{ width: '100%', marginBottom: '20px' }}
                            />
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    onClick={handleOpenCIE11}
                                    variant="contained"
                                    color="info"
                                    startIcon={<Icons.HealthAndSafety />}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{ width: 'auto' }}
                                >
                                    CIE-11
                                </Button>
                                <Button type="submit" variant="contained" color="primary">
                                    Crear historia
                                </Button>
                                <Button
                                    onClick={handleOpenRecipe}
                                    variant="contained"
                                    color="success"
                                    startIcon={<Icons.Vaccines />}
                                    disabled={!tempTratamiento && !selectedHistory?.Tratamiento}
                                >
                                    Receta
                                </Button>
                                <Button
                                    onClick={() => window.open('/drugs', '_blank')}
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<Icons.MedicalServices />}
                                >
                                    Consultar Fármacos
                                </Button>
                                <Button
                                    onClick={() => window.open('https://sedimec.dictamenmedico.com/sedimec-med/login/auth', '_blank')}
                                    variant="contained"
                                    color="info"
                                    startIcon={<Icons.History />}
                                >
                                    SEDIMEC
                                </Button>
                                <Button
                                    onClick={() => window.open('https://recetadigital.go.cr/', '_blank')}
                                    variant="contained"
                                    color="info"
                                    startIcon={<Icons.LocalPharmacy />}
                                >
                                    RECETA DIGITAL
                                </Button>
                                <Button onClick={handleClose} color="secondary">
                                    Cancelar
                                </Button>
                            </Box>
                        </form>
                    </DialogContent>
                </Dialog>
                    <Dialog
                        open={openViewModal}
                        onClose={(event, reason) => {
                            if (reason !== 'backdropClick') {
                            setOpenViewModal(false);
                            }
                        }}
                        maxWidth="md"
                        fullWidth
                        disableEscapeKeyDown
                    >
                    <DialogTitle sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}><strong>Detalles de la Historia Clínica</strong></DialogTitle>
                    <DialogContent dividers>
                        {selectedHistory && (
                            <Box sx={{ p: 2 }}>
                                <div ref={recipeRef}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>ID Historia:</strong> {selectedHistory.IDHistoria}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Fecha:</strong> {
                                            dayjs(selectedHistory.FechaDeLaHistoria)
                                                .tz('America/Costa_Rica')
                                                .format('DD/MM/YYYY HH:mm:ss')
                                        }
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Historia:</strong> {selectedHistory.HistoriaT}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Diagnóstico:</strong> {selectedHistory.Diagnostico}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Tratamiento:</strong> {selectedHistory.Tratamiento}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Responsable:</strong> {selectedHistory.Responsable}
                                    </Typography>
                                    <Typography variant="subtitle1" gutterBottom>
                                        <strong>Costo Consulta:</strong> {selectedHistory.costo_consulta}
                                    </Typography>
                                </div>
                                <DialogActions>
                                    <Button
                                        onClick={handleOpenCIE11}
                                        variant="contained"
                                        color="info"
                                        startIcon={<Icons.HealthAndSafety />}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{ width: 'auto' }}
                                    >
                                        CIE-11
                                    </Button>
                                    <Button
                                            onClick={() => {
                                                navigate(`/recipe/${selectedHistory.IDHistoria}`, {
                                                    state: {
                                                        // Pasar los datos actuales del formulario
                                                        tratamiento: selectedHistory.Tratamiento,
                                                        historia: selectedHistory.HistoriaT,
                                                        diagnostico: selectedHistory.Diagnostico,
                                                        responsable: selectedHistory.Responsable,
                                                        patient: patient,
                                                        // Añadir IDPac para mantener consistencia
                                                        IDPac: patient.idpac,
                                                        costo_consulta: selectedHistory.costo_consulta
                                                    }
                                                });
                                            }}
                                            variant="contained"
                                            color="success"
                                            startIcon={<Vaccines />}
                                            disabled={!selectedHistory.Tratamiento}
                                        >
                                            Receta
                                    </Button>
                                    <Button onClick={() => setOpenViewModal(false)} color="primary">
                                        Cerrar
                                    </Button>
                                </DialogActions>
                            </Box>
                        )}
                    </DialogContent>
                </Dialog>
                <Dialog 
                    open={openPatientInfoModal} 
                    onClose={(event, reason) => {
                        if (reason !== 'backdropClick') {
                        setOpenPatientInfoModal(false);
                        }
                    }}
                    maxWidth="md" 
                    fullWidth
                    disableEscapeKeyDown
                    >
                    <DialogTitle sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}><strong>Información del paciente</strong></DialogTitle>
                    <DialogContent>
                        {patient ? (
                            <>
                                <strong>Nombre:</strong> {patient.nombre}<br />
                                <strong>Fecha de Nacimiento:</strong> {new Date(patient.birthdate).toLocaleDateString()}<br />
                                <strong>Edad:</strong> {calcularEdad(patient.birthdate)}<br />
                                <strong>Sexo:</strong> {patient.sexo}<br />
                                <strong>Estado Civil:</strong> {patient.edocivil}<br />
                                <strong>N° Identificación:</strong> {patient.numid}<br />
                                <strong>Domicilio:</strong> {patient.domicilio}<br />
                                <strong>Email:</strong> {patient.email}<br />
                                <strong>Teléfono:</strong> {patient.tel}<br />
                                <strong>Notas:</strong> {patient.notas}<br />
                                <strong>Próxima Cita:</strong> {patient.proxcita}<br />
                            </>
                        ) : (
                            'Cargando información del paciente...'
                        )}
                    </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenPatientInfoModal(false)} color="primary">
                                Cerrar
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog 
                        open={openEditModal} 
                        onClose={(event, reason) => {
                            if (reason !== 'backdropClick') {
                            setOpenEditModal(false);
                            }
                        }} 
                        maxWidth="md" 
                        fullWidth
                        disableEscapeKeyDown
                    >
                        <DialogTitle 
                            sx={{ 
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: 2,
                                flexWrap: 'wrap',
                                fontWeight: 'bold', 
                                color: theme.palette.primary.main 
                            }}
                        >
                            {/* Columna izquierda - Título y fecha */}
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography variant="h6" component="div">
                                    Editar Historia Clínica
                                </Typography>
                                {editingHistory && (
                                    <Typography variant="subtitle2">
                                        <strong>{dayjs(editingHistory.FechaDeLaHistoria)
                                            .tz('America/Costa_Rica')
                                            .format('DD/MM/YYYY HH:mm:ss')}</strong>
                                    </Typography>
                                )}
                            </Box>

                            {/* Columna derecha - Datos del paciente */}
                            {patient && (
                                <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
                                    <strong>Nombre:</strong> {patient.nombre}<br/>
                                    <strong>Edad:</strong> {calcularEdad(patient.birthdate)}
                                </Typography>
                            )}
                        </DialogTitle>
                        <DialogContent>
                            {editingHistory && (
                                <Box component="form" sx={{ mt: 1 }}>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        label="Historia"
                                        multiline
                                        rows={12}
                                        value={editingHistory.HistoriaT}
                                        onChange={(e) => setEditingHistory({...editingHistory, HistoriaT: e.target.value})}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        label="Diagnóstico"
                                        multiline
                                        rows={4}
                                        value={editingHistory.Diagnostico}
                                        onChange={(e) => setEditingHistory({...editingHistory, Diagnostico: e.target.value})}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        label="Tratamiento"
                                        multiline
                                        rows={12}
                                        value={editingHistory.Tratamiento}
                                        onChange={(e) => setEditingHistory({...editingHistory, Tratamiento: e.target.value})}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        label="Costo Consulta"
                                        //type="number"
                                        value={editingHistory.costo_consulta}
                                        onChange={(e) => setEditingHistory({...editingHistory, costo_consulta: e.target.value})}
                                        //inputProps={{ step: "0.01" }}
                                    />
                                    <TextField
                                        fullWidth
                                        margin="normal" 
                                        label="Responsable"
                                        value={editingHistory.Responsable}
                                        onChange={(e) => setEditingHistory({...editingHistory, Responsable: e.target.value})}
                                    />
                                    <DialogActions sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'flex-end' }}>
                                    <Button
                                        onClick={() => setOpenEditModal(false)}
                                        variant="outlined"
                                        color="secondary"
                                        sx={{ minWidth: 150 }} // Tamaño consistente
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        onClick={handleUpdateHistory}
                                        variant="contained"
                                        color="primary"
                                        sx={{ minWidth: 150 }} // Tamaño consistente
                                    >
                                        Guardar Cambios
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            navigate(`/recipe/${editingHistory.IDHistoria}`, {
                                                state: {
                                                    tratamiento: editingHistory.Tratamiento,
                                                    historia: editingHistory.HistoriaT,
                                                    diagnostico: editingHistory.Diagnostico,
                                                    responsable: editingHistory.Responsable,
                                                    patient: patient,
                                                    IDPac: patient.idpac,
                                                    costo_consulta: editingHistory.costo_consulta
                                                }
                                            });
                                        }}
                                        variant="contained"
                                        color="success"
                                        startIcon={<Vaccines />}
                                        disabled={!editingHistory.Tratamiento}
                                        sx={{ minWidth: 150 }} // Tamaño consistente
                                    >
                                        Receta
                                    </Button>
                                    <Button
                                        onClick={() => window.open('/drugs', '_blank')}
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<MedicalServices />}
                                        sx={{ minWidth: 150 }} // Tamaño consistente
                                    >
                                        Consultar Fármacos
                                    </Button>
                                    <Button
                                        onClick={() => window.open('https://sedimec.dictamenmedico.com/sedimec-med/login/auth', '_blank')}
                                        variant="contained"
                                        color="info"
                                        startIcon={<Icons.History />}
                                        sx={{ minWidth: 150 }} // Tamaño consistente
                                    >
                                        SEDIMEC
                                    </Button>
                                    <Button
                                        onClick={() => window.open('https://recetadigital.go.cr/', '_blank')}
                                        variant="contained"
                                        color="info"
                                        startIcon={<Icons.LocalPharmacy />}
                                        sx={{ minWidth: 150 }} // Tamaño consistente
                                    >
                                        RECETA DIGITAL
                                    </Button>
                                </DialogActions>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
        <Dialog 
            open={deleteConfirmOpen} 
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                setDeleteConfirmOpen(false);
                }
            }}
            disableEscapeKeyDown
            >
            <DialogTitle sx={{ fontWeight: 'bold', color: theme.palette.primary.main }} >Confirmar Eliminación</DialogTitle>
            <DialogContent>
                <Typography>¿Estás seguro de que deseas eliminar esta historia clínica?</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDeleteConfirmOpen(false)}>Cancelar</Button>
                <Button onClick={confirmDelete} variant="contained" color="error">
                    Eliminar
                </Button>
            </DialogActions>
        </Dialog>
            </Paper>
        </Box>
    );
};

export default PatientHistory;